import faqsService from '../services/faqs.js';
import { GeneralContext } from '../context/GeneralContext';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from "react";

export const useFaqs = () => {

    const { user } = useContext(GeneralContext);
    const { i18n } = useTranslation();

    const [listaFaqs, setListaFaqs] = useState();

    useEffect(() => {
        faqsService.getAll(user && user.language ? user.language : elegirIdioma(i18n.language)).then(data => {
            setListaFaqs(data)
        });
    }, [user]);

    function elegirIdioma(language) {
        switch (language) {
            case "es":
                return "es-ES";
            case "en":
                return "EN";
            case "ca":
                return "ca-ES";
            case "ga":
                return "gl-ES";
            case "eu":
                return "eu-ES";
            case "va":
                return "ca-ES-valencia"
            default:
                return "es-ES";
        }
    }

    return {listaFaqs};
}